import Intents from '@ux/intents';
import { getIntents } from '../utils/intents';
const intents = new Intents();

const bdColors = {
  'product': intents.ux.boxLowContrast.borderColor,
  'info': intents.ux.feedbackInfo.feedbackColor,
  'feature': intents.ux.feedbackInternal.feedbackColor,
  'primary-midrange': intents.ux.feedback.feedbackColor
};

export default (props = {}) => {
  const bd = props.bd || props.border;
  if (!bd) return null;

  const border = {};
  if (bd === 'none') return { border: 'none' };

  if (bd.width) border.borderWidth = bd.width;
  if (bd.style) border.borderStyle = bd.style;

  const borderColor = bdColors[bd.color] || getIntents(bd.color);
  if (borderColor) border.borderColor = borderColor;

  return (Object.keys(border).length > 0) ? border : null;
};
